import EventService from '@common/event/EventService';
import VirusEvent from '../../vcom/events/VirusEvent';

function onFileUploadError(file, response, xhr) {
  if (typeof xhr === 'undefined') {
    return;
  }
  try {
    const errors = JSON.parse(response);
    if (errors.isFileMalicious !== undefined) {
      EventService.dispatch(VirusEvent.OPEN_VIRUS_FOUND_MODAL, { target: document });
      this.removeMaliciousFile(file);
      return;
    }
  } catch {
    this.onError(file, response, xhr);
    return;
  }
  this.onError(file, response, xhr);
}

const fileUpload = {
  methods: { onFileUploadError },
};

export default fileUpload;
